import { Button, TextField } from '@mui/material'
import { useState } from 'react'

import React, { useRef } from 'react'

import PropTypes from 'prop-types'

import * as Constants from '../../constants'

const Login = ({ setToken }) => {

  const [error, setError] = useState({ error: '' })

  // We are consuming our user-management context to
  // get & set the user details here
  //const { user, fetchUser, emailPasswordLogin } = useContext(UserContext);

  // We are using React's "useState" hook to keep track
  //  of the form values.
  const [form, setForm] = useState({
    username: '',
    password: '',
  })

  // This function will be called whenever the user edits the form.
  const onFormInputChange = (event) => {
    const { name, value } = event.target
    setForm({ ...form, [name]: value })
  }

  async function loginUser(username, password) {
    return fetch(Constants.HOST + '/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ username: username, password: password }),
    }).then((data) => data.json())
  }

  // This function gets fired when the user clicks on the "Login" button
  const onSubmit = async (event) => {
    try {
      const token = await loginUser(form.username, form.password)

      if (token && token.token) {
        setToken(token)
      } else {
        // Show HTML error message ( material )
        setError({ error: 'Usuário ou senha incorretos.' })
        shake()
      }
    } catch (error) {
      console.log(error)
      alert(error)
    }
  }

  const formRef = useRef(null)

  const shake = async () => {
    console.log(formRef.current)
    const form = await formRef.current.style
    const interval = setInterval(move, 1)
    let px = 25
    function move() {
      form.padding = '0 ' + px + 'px 0 0'
      px = px < 0 ? px * -1 - 1 : px * -1 + 1
      if (px === 1) clearInterval(interval)
    }
  }

  return (
    <form
      style={{
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '300px',
        margin: 'auto',
      }}
      onKeyUp={(event) => {
        if (event.key === 'Enter') onSubmit()
      }}
      ref={formRef}
    >
      <h1>ARM Login</h1>

      {error.error && (
        <div style={{ color: 'red', margin: '10px 0' }}>{error.error}</div>
      )}
      <TextField
        label="Usuário"
        type="username"
        variant="outlined"
        name="username"
        autoComplete="username"
        value={form.username}
        onChange={onFormInputChange}
        style={{ marginBottom: '1rem' }}
      />
      <TextField
        label="Senha"
        type="password"
        variant="outlined"
        name="password"
        autoComplete="current-password"
        value={form.password}
        onChange={onFormInputChange}
        style={{ marginBottom: '1rem' }}
      />
      <Button variant="contained" color="primary" onClick={onSubmit}>
        Acessar
      </Button>
    </form>
  )
}

Login.propTypes = {
  setToken: PropTypes.func.isRequired,
}

export default Login
